import {
	BPanel,
	Button,
	Form,
	FormGroup,
	Col,
	ControlLabel,
	FormControl,
	Breadcrumb,
} from '@sketchpixy/rubix';
import { Router, Link, browserHistory, withRouter } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Reactive } from '../common/Reactive.mixin.js';

import { Meteor } from 'meteor/meteor';

import { FlightsType } from '../../collections/flights-type/flights-type';
import { Options } from '../../collections/flights-type/options';
import { Prices } from '../../collections/flights-type/prices';
import { Promotions } from '../../collections/flights-type/promotions';
import { CirclePicker } from 'react-color';

@withRouter
@Reactive({
	subscriptions: ["flights-type"]
})
export default class FlightsTypeFormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    if(this.props.params.id)
      this.flight = FlightsType.find({_id: this.props.params.id}).fetch()[0];
    else
      this.flight = {};
    this.state.prices = Prices.find({partnerId: null}, { sort: { 'title': 1 } }).fetch();
    this.state.options = Options.find({}, { sort: { 'title': 1 } }).fetch();
    this.state.promotions = Promotions.find({}, { sort: { 'title': 1 } }).fetch();

    if(!this.flight)
        this.state.color = "#03a9f4";
    else
        this.state.color = this.flight.color;
  }

  handleSubmit(e) {
    e.preventDefault();

  	let newFlight = {};
    let params = {};
    let message = null;
    let method = null;

    params.attributes = {};
  	_.each(this.refs, (ref, key) => {
      if(ReactDOM.findDOMNode(ref).type == 'select-multiple') {
          let option
          let node = ReactDOM.findDOMNode(ref);
          let options = [].slice.call(node.querySelectorAll('option'));
          let selected = options.filter(function (option) {
              return option.selected;
          });
          let selectedValues = selected.map(function (option) {
              return option.value;
          });
          params.attributes[key] = selectedValues;
      } else {
        params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();
      }
  	});

    params.attributes['color'] = this.state.color;

    if(this.props.params.id) {
      message = "Le vol a été modifié avec succès.";
      method = "flightsType.update";
      params._id = this.props.params.id;
    }
    else {
      message = "Le vol a été ajouté avec succès.";
      method = "flightsType.insert";
      params.attributes["createdAt"] = new Date();
    }

    Meteor.call(method, params, (function (err, _id) {

        if (err) {
          Messenger().post({
            message: err,
            type: "error"
          });
          return ;
        }

        Messenger().post({
          message: message,
          type: "success"
        });

		this.props.router.push('/flights');
      }).bind(this));
  }

  selectPlace(event) {
    if(event.target.value == 'aucune') {
      this.setState({
        prices: Prices.find()
      });
    }
    else {
      this.setState({
        prices: Prices.find({constraintPlace:{$in: [event.target.value]}}).fetch()
      });
    }

  }

  selectColor(color, event) {
        console.log(color);
        console.log(event);
        this.setState({
            color: color.hex
        });
        console.log(this.state);
  }

  renderPrices() {
    return this.state.prices.map((price) => (
      <option value={price._id}>{price.title} : {price.price}€</option>
    ));
  }

  renderPromotions() {
    return this.state.promotions.map((promotion) => (
      <option value={promotion._id}>{promotion.title}</option>
    ));
  }

  renderOptions() {
    return this.state.options.map((option) => (
      <option value={option._id}>{option.title} : {option.price}€</option>
    ));
  }

  render() {
    return (
      <div>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/flights">Vols</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="#" active>
              Ajouter un vol
            </Breadcrumb.Item>
          </Breadcrumb>

          <BPanel header="Ajouter un vol">
            <Form horizontal onSubmit={this.handleSubmit.bind(this)}>
              <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={3}>
                  Titre du vol
                </Col>
                <Col sm={9}>
                <FormControl type="text" ref="title" defaultValue={this.flight.title}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Description du vol
                </Col>
                <Col sm={9}>
                <FormControl componentClass="textarea" ref="description" defaultValue={this.flight.description}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Couleur
                </Col>
                <Col sm={9}>
                  <CirclePicker onChangeComplete={::this.selectColor} color={this.state.color}/>
                </Col>
              </FormGroup>

              <hr/>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Nombre de passagers minimum *
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="constraintPassengerMin" defaultValue={this.flight.constraintPassengerMin}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Nombre de passagers maximum *
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="constraintPassengerMax" defaultValue={this.flight.constraintPassengerMax}/>
                </Col>
              </FormGroup>

              <hr/>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Prix SEMAINE
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="priceSemaine" defaultValue={this.flight.priceSemaine}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Prix LIBRE DATE
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="priceLibreDate" defaultValue={this.flight.priceLibreDate}/>
                </Col>
              </FormGroup>

            <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Prix ENFANT
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="priceEnfant" defaultValue={this.flight.priceEnfant}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Conditions de remboursement
                </Col>
                <Col sm={9}>
                <FormControl componentClass="textarea" ref="remboursement" defaultValue={this.flight.remboursement}/>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Info sur le billet
                </Col>
                <Col sm={9}>
                <FormControl type="text" ref="infoBillet" defaultValue={this.flight.infoBillet}/>
                </Col>
              </FormGroup>

              <hr/>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Options possibles
                </Col>
                <Col sm={9}>
                    <FormControl componentClass="select" placeholder="select" ref="optionIds" multiple defaultValue={this.flight.optionIds}>
											<option value="">Aucune options</option>
											{this.renderOptions()}
                    </FormControl>
                </Col>
              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Promotions possibles
                </Col>
                <Col sm={9}>
                    <FormControl componentClass="select" placeholder="select" ref="promotionIds" multiple defaultValue={this.flight.promotionIds}>
											<option value="">Aucune promotions</option>
											{this.renderPromotions()}
                    </FormControl>
                </Col>
              </FormGroup>

              <hr/>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={3}>
                  Référence*
                </Col>
                <Col sm={2}>
                <FormControl type="text" ref="reference" defaultValue={this.flight.reference}/>
                </Col>
                <Col sm={7}>
                  <small>* laisser vide si ce vol n'existe pas sur le site.</small>
                </Col>
              </FormGroup>

              <FormGroup>
                <Col smOffset={2} sm={10}>
                <Button type="submit">
                  Enregistrer
                </Button>
                </Col>
              </FormGroup>
            </Form>
          </BPanel>
      </div>
    );
  }
}

FlightsTypeFormPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights-type/FlightsTypeForm.page.js
 **/